<al-period-sums (click)="toggleExpand()"
                [actualHours]="actualHours"
                [plannedHours]="assignedHours"
                [isVisible]="true"
                class="portal-clickable portal-fill portal-flex-center" />

<al-cell-drop-zone [node]="node"
                      [droppable]="isDroppable"
                      [period]="period?.hasActualHours ? undefined : period"
                      (dragOverDelay)="expand()" />